module.exports = __webpack_public_path__ + "img/vertical_7_1_8019.5937443b.png";